import { CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetContact =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.contact_us.get;
      const response = await PostFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageContactUs =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      var bodyFormData = {};
      if (editMode) {
        bodyFormData.id = values?.id;
      }
      if (CheckDataIfExit(values?.email)) {
        bodyFormData.email = values?.email?.trim();
      }
      if (CheckDataIfExit(values?.email)) {
        bodyFormData.email2 = values?.email2?.trim();
      }
      if (CheckDataIfExit(values?.email)) {
        bodyFormData.email3 = values?.email3?.trim();
      }
      if (CheckDataIfExit(values?.phone_number)) {
        bodyFormData.phone_number = values?.phone_number;
      }
      if (CheckDataIfExit(values?.phone_number2)) {
        bodyFormData.phone_number2 = values?.phone_number2;
      }
      if (CheckDataIfExit(values?.phone_number3)) {
        bodyFormData.phone_number3 = values?.phone_number3;
      }
      if (CheckDataIfExit(values?.location)) {
        bodyFormData.location = values?.location;
      }
      if (CheckDataIfExit(values?.map)) {
        bodyFormData.map = values?.map?.trim();
      }
      const response = await PostFunction({
        data: bodyFormData,
        Route: editMode ? UrlApi.contact_us.edit : UrlApi.contact_us.add,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditContactUs =
  ({ callback, allData, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      if (allData) {
        data = allData;
      } else {
        data = {
          id: id,
          [nameFailed]: dataFailed,
        };
      }
      const response = await PostFunction({
        data,
        Route: UrlApi.contact_us.edit,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const DeleteContactUs =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data = {
        idscontactus: id,
      };
      const response = await PostFunction({
        data,
        Route: UrlApi.contact_us.delete,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
